// 设备型号
export const deviceModels = [
  {value: 'C01', name: '3024', label: 'GPSC3024'},
  {value: 'C02', name: '6048', label: 'GPSC6048'},
  {value: 'C03', name: '1524', label: 'GPSC1524'},
  {value: 'C04', name: '8080', label: 'GPSC8080'},
  {value: 'C05', name: '1724', label: 'GPSC1724'},
  {value: 'C06', name: '3548', label: 'GPSC3548'},
  {value: 'C07', name: '', label: 'CTB-01'},
  {value: 'C08', name: '10048', label: 'GPSC10048'}
]

// 8080，10048 客户类型
export const clientOptions = [
  {value: '00', name: 'PY', label: '默认(PY)'},
  {value: '01', name: 'XB', label: '星邦(XB)'},
  {value: '02', name: 'DL', label: '鼎力(DL)'},
  {value: '03', name: 'ZL', label: '中联(ZL)'},
  {value: '04', name: 'XG', label: '徐工(XG)'},
  {value: '05', name: 'LG', label: '临工(LG)'},
  {value: '06', name: 'ZF', label: '中福(ZF)'}
]

export function getClientValue (lable) {
  const obj = clientOptions.find(item => item.name == lable)
  if (obj) {
    return obj.value
  }
  return '00'
}


// 其他设备客户类型
export const clientOptionsOfOther = [
  {value: '01', label: 'PY-01'},
  {value: '02', label: 'DL-02'},
  {value: '03', label: 'PY-41'}
]


// 8080的硬件型号
export const hardwareOptions = [
  {value: '00', label: 'SC78660803-01'},
  {value: '01', label: 'SC78660804-01'},
  {value: '02', label: 'SC78660804-02'},
  {value: '03', label: 'SC78660805-01'},
  {value: '04', label: 'SC78660806-01'}
]

export function getHardwareValue (lable) {
  const obj = hardwareOptions.find(item => item.label == lable)
  if (obj) {
    return obj.value
  }
  return '00'
}

// 10048 硬件型号
export const hardwareOptions10048 = [
  {value: '00', label: 'SC74501004-01'},
  {value: '01', label: 'SC74501005-01'},
  {value: '02', label: 'SC74501006-01'}
]

export function getClientName(m, val) {
  console.log(m, val)
  if (m.indexOf('C0')>= 0) m = m.slice(0, 3)
  if (m == 'GPSC8080' || m == 'C04' || m == 'GPSC10048' || m == 'C08') {
    const obj = clientOptions.find(item => item.value == val)
    if (obj) return obj.name
  }else {
    const obj = clientOptionsOfOther.find(item => item.value == val)
    if (obj) return obj.label
  }
  return 'PY'
}

export function getHardwareName(m, val) {
  console.log(m, val)
  if (m.indexOf('C0')>= 0) m = m.slice(0, 3)
  if (m == 'GPSC8080' || m == 'C04') {
    const obj = hardwareOptions.find(item => item.value == val)
    if (obj) return obj.label
  }else if (m == 'GPSC10048' || m == 'C08') {
    const obj = hardwareOptions10048.find(item => item.value == val)
    if (obj) return obj.label
  }
  return '01'
}